/**
 * @description Domain enum
 */
export enum Domain {

	/**
	 * @description Localhost
	 * @type {string}
	 */
	LOCALHOST = 'localhost',

	/**
	 * @description Paramount+ domain
	 * @type {string}
	 */
	PPLUS = 'paramountplus.com',

	/**
	 * @description cbs.com domain
	 * @type {string}
	 */
	CBSCOM = 'cbs.com',

	/**
	 * @description pluto.tv domain
	 * @type {string}
	 */
	PTV = 'pluto.tv',

}